/**
 * @generated SignedSource<<b1d1e0f37c8e14b9289901fb3b7ef878>>
 * @relayHash 0924bfd3f5fb2cfba5ee5bef514c4354
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 278d23eb501160120455ec96532fe09eadf1071e668f0a90c7b66c04010924cc

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SupportWebsiteOverviewQuery } from './SupportWebsiteOverviewQuery.graphql';

const node: PreloadableConcreteRequest<SupportWebsiteOverviewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "278d23eb501160120455ec96532fe09eadf1071e668f0a90c7b66c04010924cc",
    "metadata": {},
    "name": "SupportWebsiteOverviewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
